
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/ubytovanie",
      function () {
        return require("private-next-pages/[region]/ubytovanie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/ubytovanie"])
      });
    }
  